const initialState = {
  errorMessage: null,
  ready: false,
  sideMenuCollapsed: true,
};

const application = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ERROR_MESSAGE':
      return {
        ...state,
        errorMessage: action.message,
      };

    case 'RESET_ERROR_MESSAGE':
      return {
        ...state,
        errorMessage: null,
      };

    case 'SET_APPLICATION_READY':
      return {
        ...state,
        ready: true,
      };

    case 'SET_SIDE_MENU_COLLAPSED':
      return {
        ...state,
        sideMenuCollapsed: !state.sideMenuCollapsed,
      };

    default:
      return state;
  }
};

export const getErrorMessage = (state) => state.errorMessage;

export const isReady = (state) => state.ready;

export const sideMenuCollapsed = (state) => state.sideMenuCollapsed;

export default application;
